import React from "react";

export default function ConsentAcknowledgment() {
  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Consent and Acknowledgment</h2>
      <div className="grid grid-cols-1 gap-6">
        <div>
          <label className="block mb-1">Consent for Treatment</label>
          <textarea
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Consent Details"
          ></textarea>
        </div>
      </div>
    </div>
  );
}
